import { render, staticRenderFns } from "./AboutCaseManagementOrder.vue?vue&type=template&id=b91a810c"
import script from "./AboutCaseManagementOrder.vue?vue&type=script&lang=ts"
export * from "./AboutCaseManagementOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports